import React, { useState, useEffect } from "react";
import { Input } from "antd";

export const ThousandSeparatorInput = ({
  value,
  onChange,
  className,
  onBlur,
  onClear,
  status,
  allowClear = true,
  ...props
}) => {
  const [displayValue, setDisplayValue] = useState("");

  // Sync external value (Formik or parent)
  useEffect(() => {
    if (value !== undefined && value !== null && value !== "") {
      const numeric = parseFloat(value);
      if (!isNaN(numeric)) {
        // Show with commas but keep decimals as typed
        const parts = value.toString().split(".");
        const integerPart = Number(parts[0]).toLocaleString("en-US");
        const decimalPart = parts[1] ? "." + parts[1].slice(0, 2) : "";
        setDisplayValue(integerPart + decimalPart);
      } else {
        setDisplayValue(value);
      }
    } else {
      setDisplayValue("");
    }
  }, [value]);

  const handleChange = (e) => {
    let rawValue = e.target.value.replace(/,/g, "");

    // Allow only digits and one decimal point with up to 2 decimals
    if (!/^\d*\.?\d{0,2}$/.test(rawValue)) return;

    // Format integer part with commas
    const parts = rawValue.split(".");
    const integerPart = parts[0]
      ? Number(parts[0]).toLocaleString("en-US")
      : "";
    const decimalPart = parts[1] !== undefined ? "." + parts[1] : "";

    const formattedValue = integerPart + decimalPart;
    setDisplayValue(formattedValue);

    if (onChange) {
      onChange({
        target: {
          name: props.name,
          value: rawValue, // send pure numeric string back to formik
        },
      });
    }
  };

  const handleClear = () => {
    setDisplayValue("");
    if (onChange) {
      onChange({
        target: {
          name: props.name,
          value: "",
        },
      });
    }
    if (onClear) onClear();
  };

  return (
    <Input
      value={displayValue}
      className={className}
      onChange={handleChange}
      status={status}
      size="large"
      allowClear={allowClear}
      onClear={handleClear}
      onBlur={onBlur}
      {...props}
    />
  );
};
